import React from 'react';
import classNames from 'classnames';
import { formatBookingCodeLabel, resolveBookingCode } from '../../util/bookingCode';
import css from './BookingCodeBadge.module.css';

/**
 * Displays a booking reference pill, e.g. "Booking #BK-000123".
 */
const BookingCodeBadge = ({
  bookingCode,
  metadata,
  booking,
  className,
  compact = false,
  showPrefix = true,
  unavailableLabel = null,
}) => {
  const code = resolveBookingCode({ bookingCode, metadata, ...booking });
  if (!code) {
    if (!unavailableLabel) return null;
    return (
      <span
        className={classNames(css.badge, css.unavailable, compact && css.compact, className)}
        data-booking-code-badge
      >
        {unavailableLabel}
      </span>
    );
  }

  const label = showPrefix ? formatBookingCodeLabel(code) : code;

  return (
    <span className={classNames(css.badge, compact && css.compact, className)} data-booking-code-badge>
      {label}
    </span>
  );
};

export default BookingCodeBadge;
